import { Model } from 'modules/core/lib/mobx-rest'

interface ITaxResidence {
  [key: string]: any
}
class TaxResidence extends Model<ITaxResidence> {
  static urlRoot() {
    return '/payroll/tax_residences'
  }
}

export default TaxResidence
